<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectTypes" });
import { SelectMultiple } from "../../../../selects/index.js";
import { ORGANIZATION_TYPES } from "../config.js";
import { t } from "svelte-i18n";
import { SESSION_ORGANIZATION } from "../../../authentication/services/store.js";
export let keys;
export let domain = $SESSION_ORGANIZATION?.domain ?? "buyer";
export let isDisabled = false;
export let isBlackList = false;
export let minItems = 1;
export let maxItems = 100;
export let label = "resource.organization.properties.type.label";
export let placeholder = "resource.organization.properties.type.placeholder";
$: options = ORGANIZATION_TYPES.filter((item) => item.domain === domain).map((option) => ({ ...option, label: $t(option.label) }));
$: if (isBlackList) {
    maxItems = options.length - 1;
}
</script>

<SelectMultiple
    bind:keys
    name = 'organization.types'
    hasSearch = { false }
    { isDisabled }
    { label }
    { maxItems }
    { minItems }
    { options }
    { placeholder }
/>